import React from 'react';

import {
  Badge,
  Box,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Show,
  Text,
} from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

import { VideoDetailsType } from '../../types';

export function AiBadge({ aiContent }: { aiContent: VideoDetailsType['aiContent'] }) {
  const hasAiVisual = aiContent?.visual || aiContent?.visualAuto;
  const hasAiAudio = aiContent?.audio || aiContent?.audioAuto;

  if (!hasAiVisual && !hasAiAudio) {
    return null;
  }

  const replacements = {
    LINE_BREAK: () => <br />,
    LINK: (text: string) => (
      <Box
        _hover={{ cursor: 'pointer' }}
        as="a"
        textDecoration="underline"
        href="https://vimeo.com/help/zendesk_sso?redirect_to=https://help.vimeo.com/hc/en-us/articles/25551485186833/"
        target="_blank"
        rel="noopener noreferrer"
      >
        {text}
      </Box>
    ),
  };

  let labelContent;
  switch (true) {
    case !hasAiVisual && !hasAiAudio:
      break;
    case hasAiVisual && hasAiAudio:
      labelContent = translate({
        singular:
          'This video contains audio and visuals that were edited or generated using AI. {LINE_BREAK}{LINK}Learn more{/LINK}',
        replacements,
      });
      break;
    case hasAiVisual && !hasAiAudio:
      labelContent = translate({
        singular:
          'This video contains visuals that were edited or generated using AI. {LINE_BREAK}{LINK}Learn more{/LINK}',
        replacements,
      });
      break;
    case !hasAiVisual && hasAiAudio:
      labelContent = translate({
        singular:
          'This video contains audio that was edited or generated using AI. {LINE_BREAK}{LINK}Learn more{/LINK}',
        replacements,
      });
      break;
  }

  if (!labelContent) return null;

  const badgeContent = (
    <Badge variant="not-yet-rated" size="sm" color="text-secondary" borderColor="text-secondary">
      {translate('Includes AI')}
    </Badge>
  );

  return (
    <>
      <Show below="md">{badgeContent}</Show>
      <Show above="md">
        <Popover placement="top" trigger="hover">
          <PopoverTrigger>{badgeContent}</PopoverTrigger>
          <PopoverContent maxW={320} py={75} px={100}>
            <PopoverBody>
              <Text textAlign="left" variant="body-md">
                {labelContent}
              </Text>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      </Show>
    </>
  );
}
